import http from './index'

const getCountries = async () => {
    return await http.get('/get/countries')
}

export { getCountries }
